module.exports = __webpack_public_path__ + "img/photo-shifter.8abce2d7.png";